<template>
  <div class="fertilizer">
    <div class="box">
      <img src="./ball.gif" width="63" height="110" alt="Ball">
    </div>
    <div class="updated">3 II 2006</div>
  </div>
</template>

<script>
export default {
  name: "Ball"
};
</script>

<style scoped>
.fertilizer {
  background-color: #660046;
}
.box {
  margin-top: -60px;
}
.updated {
  color: #fff;
}
</style>
